import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSliderModule } from '@angular/material/slider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { GeoMapPrecastComponent } from './geo-map-precast.component';
import { GeoMapPrecastRoutingModule } from './geo-map-precast.routing.module';
import { MixDesignListDialogComponent } from './components/mix-design-list-dialog/mix-design-list-dialog.component';

@NgModule({
  declarations: [GeoMapPrecastComponent, MixDesignListDialogComponent],
  imports: [
    CommonModule,
    GeoMapPrecastRoutingModule,
    RouterModule,
    MatDialogModule,
    MatSelectModule,
    MatSliderModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
  ],
})
export class GeoMapPrecastModule {}
